<template>
  <div>
    <div class="source">
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$http = axios
export default {
  name: 'GoodsImg',
  beforeCreate: function () {
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsImg.vue